import { Component, OnInit, OnDestroy } from "@angular/core";
import { UserManager } from "src/app/Services/UserManager/user-manager";
import { AngularFireDatabase } from "@angular/fire/database";
import { Subject } from "rxjs";
import { Profile } from "src/app/Models/profile.interface";
import _ from "lodash";
import { transition, style, animate, trigger } from "@angular/animations";
import { AngularFirestore } from "@angular/fire/firestore";
import { ORGS, PROFILES } from "src/Constants";

@Component({
  selector: "app-my-school",
  templateUrl: "./my-school.component.html",
  styleUrls: [
    "./my-school.component.css",
    "../../components/lesson-blocks/lesson-blocks.component.css",
  ],
  animations: [
    trigger("item", [
      transition(":enter", [
        style({ height: 0, transform: "scale(0)", opacity: 0 }),
        animate(
          "300ms 500ms",
          style({ height: "*", transform: "scale(1)", opacity: 1 })
        ),
      ]),
      transition(":leave", [
        style({ height: "*", transform: "scale(1)", opacity: 1 }),
        animate(
          "100ms",
          style({ height: 0, transform: "scale(0)", opacity: 0 })
        ),
      ]),
    ]),
  ],
})
export class MySchoolComponent implements OnInit, OnDestroy {
  leaving = new Subject();
  profile: Profile;
  authLevel;
  org;
  orgsub;
  invitationLink = "";
  orgs = [];
  change = new Subject();

  constructor(
    private um: UserManager,
    private db: AngularFireDatabase,
    private afs: AngularFirestore
  ) {}
  ngAfterViewInit() {
    setTimeout(() => {
      this.um
        .getProfileSubject()
        .takeUntil(this.leaving)
        .subscribe((profile) => {
          if (!_.isEqual(profile, this.profile)) {
            this.profile = profile;
            !!profile && this.getOrgs();
          }
        });
    }, 0);
  }

  orgnizationChange = ({ value: org }) => {
    this.setOrg(org);
  };

  setOrg = async (org) => {
    this.org = org;
    // try{
    //   await this.um.updateProfile(prof)
    // } catch(e) {
    //   console.error(e)
    // } finally {
    //   location.reload()
    // }
  };

  getOrgs = async () => {
    this.orgs = []; // clear orgs first
    // check if superadmin

    let superAdmin = await this.isSuperAdmin();

    try {
      if (superAdmin) {
        this.afs
          .collection(ORGS, (ref) => ref.orderBy("name", "desc"))
          .valueChanges()
          .take(1)
          .subscribe((orgs) => {
            this.orgs = orgs;
            //@ts-ignore
            this.org = _.filter(orgs, (o) => o.entityId === "iiw")[0];
          });
      } else {
        let hasAccess = await this._checkAccess();
        if (!hasAccess) {
          console.error("Access Denied");
          return;
        }
        const uid = this.profile?.uid;

        this.afs
          .collection(PROFILES)
          .doc(uid)
          .collection(ORGS)
          .snapshotChanges()
          .take(1)
          .subscribe((orgs) => {
            let k = [];
            orgs.forEach((o) => k.push(o.payload.doc.id));
            _.forEach(k, (key) => {
              this.afs
                .collection(ORGS)
                .doc(`${key}`)
                .valueChanges()
                .take(1)
                .subscribe(this.addOrg);
            });
          });
      }
      if (this.authLevel) {
        this.getPrivalegedSubscription();
      }
    } catch (e) {
      console.error(e);
    }
  };

  addOrg = (org) => {
    this.orgs.push(org);
  };

  gotoLink = () => {
    this.um.gotoLink();
  };

  isSuperAdmin = async () => {
    if (!this.profile) {
      return false;
    }
    let sup = await this.afs
      .collection("Admins")
      .doc<{ approved: boolean }>(`${this.profile.uid}`)
      .valueChanges()
      .take(1)
      .toPromise();
    if (sup?.approved) {
      this.authLevel = "admin";
      return true;
    } else {
      return false;
    }
  };

  _checkAccess = async () => {
    let { uid } = this.profile;
    const id = this?.org?.id || this.profile?.organization;

    let admin = await this.afs
      .collection("Permissions")
      .doc(`${id}`)
      .collection("Admins")
      .doc<{ approved: boolean }>(`${uid}`)
      .valueChanges()
      .take(1)
      .toPromise();
    let instructor = await this.afs
      .collection("Permissions")
      .doc(`${id}`)
      .collection("Instructors")
      .doc<{ approved: boolean }>(`${uid}`)
      .valueChanges()
      .take(1)
      .toPromise();

    if (instructor?.approved) {
      this.authLevel = "instructor";
    }

    if (admin?.approved) {
      this.authLevel = "admin";
    }

    return !!this.authLevel;
  };

  getPrivalegedSubscription() {
    if (this.authLevel) {
      this.afs
        .doc(`Organizations/${this.profile.organization}`)
        .valueChanges()
        .takeUntil(this.leaving)
        .subscribe((o) => {
          this.org = o;
          this.invitationLink = `www.itiswritten.study/register/${o["entityId"]}`;
        });
    }
  }

  ngOnDestroy(): void {
    this.leaving.next(null);
  }

  ngOnInit(): void {}
}
